<template>
  <div>
    <button v-if="!confirm" @click="setConfirm" class="btn btn-light btn-sm">
      <i class="fa fa-trash-alt mr-1"></i> <span v-if="label">{{ label }}</span>
    </button>
    <button
      v-if="confirm"
      @click="confirmed"
      class="btn btn-danger btn-sm animate__bounceIn"
      :disabled="working"
    >
      <i class="fa fa-exclamation fs-3 fw-boldest text-white mx-1"></i
      ><span v-if="label">Sí, {{ label }}</span>
    </button>
  </div>
</template>
<script>
export default {
  name: "reset-password",
  props: {
    label: {
      type: String,
      default: "",
    },
    userId: {
      type: Number,
      default: 0,
    },
  },
  data: () => {
    return {
      working: false,
      confirm: false,
    };
  },
  methods: {
    setConfirm() {
      this.confirm = true;

      setTimeout(() => {
        this.confirm = false;
      }, 3000);
    },
    async confirmed() {
      this.working = true;

      try {
        const response = await this.$api.post(
          `users/${this.userId}/reset-password`
        );

        this.$emit("onReset", true);

        this.confirm = false;

        this.$notiflix.Report.success(
          "Contraseña restablecida",
          `La nueva contraseña es: \n<strong>${response.data}</strong>`,
          "Enterado"
        );
      } catch (error) {
        console.log(error);
        this.$notiflix.Notify.failure(
          `No fue posible reiniaizar la contraseña`
        );
      } finally {
        this.working = false;
      }
    },
  },
};
</script>
